/**
 * 专家管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>专家管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userkey" placeholder="输入姓名/部门"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
         <el-button size="small" type="primary" icon="el-icon-add" @click="addzhuanjia()">新加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="doctor_name" align="center" label="姓名" width="100">
      </el-table-column>
      <el-table-column prop="doctor_sex" align="center" label="性别" width="60">
        <template slot-scope="scope">
            <div v-if="scope.row.sex == 1">男</div>
            <div v-else-if="scope.row.sex == 2">女</div>
            <div v-else>未知</div>
        </template>
      </el-table-column>
       <el-table-column prop="picture" label="头像" align="center">
                              <template   slot-scope="scope">
                                  <img :src="scope.row.doctor_img"  min-width="100" height="120" />
                              </template>
                          </el-table-column>


      <el-table-column prop="department_name" label="科室" width="100">
      </el-table-column>


      <el-table-column prop="zc" label="职称" width="100">
      </el-table-column>
      <el-table-column prop="sort" label="排序(升序排列)" width="100">
      </el-table-column>
      <el-table-column prop="des" label="医生介绍">
      </el-table-column>
      <el-table-column prop="status" align="center" label="是否显示" width="60">
        <template slot-scope="scope">
            <div v-if="scope.row.status == 1" style="color:green;font-weight:bold">显示</div>
            <div v-else-if="scope.row.status == 0" style="color:#cccc">不显示</div>

        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="editzhuanjia(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑医生信息 -->
    <el-dialog title="医生信息" :visible.sync="doctorinfoVisible">
      <el-form :model="form">
        <el-form-item label="医生头像">
          <el-upload
            class="avatar-uploader"
            action="/api/system/uploadImg"
            :headers="upheader"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="form.doctor_img" :src="form.doctor_img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="border: 1px dashed #d9d9d9;">

            </i>
          </el-upload>
          <el-button v-if="form.doctor_img" @click="removepic" type="danger" icon="el-icon-close" circle style="padding: 5px;position: relative;left: 150px;top: -20px;"></el-button>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input type="text" v-model="form.doctor_name" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>
        <el-form-item label="职称">
          <el-input type="text" v-model="form.zc" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>


        <!-- <el-radio v-model="sex" label="1" >男</el-radio>
         <el-radio v-model="sex" label="2" >女</el-radio> -->



        <el-form-item label="科室">
          <el-input type="text" v-model="form.department_name" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>
        <el-form-item label="性别">
         <el-radio-group v-model="sex">
             <el-radio :label="1">男</el-radio>
             <el-radio :label="2">女</el-radio>

           </el-radio-group>
        </el-form-item>
        <el-form-item label="医生简介">
          <el-input type="textarea" v-model="form.des" style="width: 100%;"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="text" v-model="form.sort" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
         <el-radio-group v-model="is_show">
             <el-radio :label="1">显示</el-radio>
             <el-radio :label="0">不显示</el-radio>

           </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加信息 -->
    <el-dialog title="医生信息" :visible.sync="doctorinfoVisibleadd">
      <el-form :model="form">
        <el-form-item label="医生头像">
          <el-upload
            class="avatar-uploader"
            action="/api/system/uploadImg"
            :headers="upheader"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="form.doctor_img" :src="form.doctor_img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="border: 1px dashed #d9d9d9;">

            </i>
          </el-upload>
          <el-button v-if="form.doctor_img" @click="removepic" type="danger" icon="el-icon-close" circle style="padding: 5px;position: relative;left: 150px;top: -20px;"></el-button>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input type="text" v-model="form.doctor_name" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>
        <el-form-item label="职称">
          <el-input type="text" v-model="form.zc" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>


        <!-- <el-radio v-model="sex" label="1" >男</el-radio>
         <el-radio v-model="sex" label="2" >女</el-radio> -->



        <el-form-item label="科室">
          <el-input type="text" v-model="form.department_name" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>
        <el-form-item label="性别">
         <el-radio-group v-model="sex">
             <el-radio :label="1">男</el-radio>
             <el-radio :label="2">女</el-radio>

           </el-radio-group>
        </el-form-item>
        <el-form-item label="医生简介">
          <el-input type="textarea" v-model="form.des" style="width: 100%;"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="text" v-model="form.sort" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
         <el-radio-group v-model="is_show">
             <el-radio :label="1">显示</el-radio>
             <el-radio :label="0">不显示</el-radio>

           </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { zhuanjialist,zhuanjiaInfo } from '../../api/baseset'

  export default {
    data() {
      return {
            loading: false, //是显示加载
            doctorinfoVisible: false,
            doctorinfoVisibleadd:false,
            formInline: {
              page: 1,
              limit: 10
            },
            imageUrl: '',
            sex:'',
            is_show:'',
            listData: [], //表格数据
            form: {
              doctorpic: '',
              doctorinfo: '',
              doctor_img:''
            },
            // 分页参数
            pageparm: {
              currentPage: 1,
              pageSize: 10,
              total: 10
            },
            upheader: {
              token: localStorage.getItem('logintoken')
            }
          }
    },
    // 注册组件
    components: {
      Pagination
    },
    created(){
      this.getdata(this.formInline);
    },
    methods:{
      getdata(parameter) {
        this.loading = true
        zhuanjialist(parameter).then(res => {
            this.loading = false
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      // 重置搜索
      formReset() {
        this.formInline.userkey = '';
      },
      // 图片上传
      handleAvatarSuccess(res, file) {
        this.form.doctor_img = res.data;
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const imgarr = ['image/jpeg','image/png','image/jpg','image/gif'];
        const isImg = imgarr.indexOf(file.type) !== -1;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isImg) {
          this.$message.error('上传文件格式不正确，请上传图片！');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isImg && isLt2M;
      },
      editzhuanjia(row) {
        this.form = row;
        console.log(row)
        this.doctorinfoVisible = true;
        this.sex = row.sex;
        this.is_show=row.status;
        console.log(this.sex);
      },

      addzhuanjia(row) {

        this.doctorinfoVisibleadd = true;

      },
      removepic() {
        this.form.doctor_img ='';
      },
      submitform() {
        let data = {
          id:this.form.id,
          doctor_name:this.form.doctor_name,
          department_name:this.form.department_name,
          doctor_img:this.form.doctor_img,
          sex:this.sex,
          des:this.form.des,
          zc:this.form.zc,
          status:this.is_show,
          sort:this.form.sort,
          }
          console.log(data);
          //return ;
        this.loading = true;
        zhuanjiaInfo(data).then(res => {
          this.loading = false;
          this.doctorinfoVisible = false;
          this.doctorinfoVisibleadd = false;
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.getdata(this.formInline);
            // location.reload();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false;
          this.deptinfoVisible = false;
          this.$message.error('修改失败，请稍后再试！')
        })
      }
    }

  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-radio-group{
    margin-left: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/base/Zhuanjia.vue